import {Platform, StyleSheet} from 'react-native';
import {COLORS, FONTS} from '../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (imageContainer, rowItem) are preserved — the factory returns them closed
// over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    headerContainer: {
      position: 'absolute',
      zIndex: 2,
      left: 0,
      right: 0,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginHorizontal: 24,
      marginTop: 24,
    },
    imageContainer: width => ({
      width: Platform.OS === 'web' ? 0.3 * width : width,
      aspectRatio: 375 / 325,
    }),
    productImage: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      left: 0,
      top: 0,
    },
    gradiantView: {
      width: '100%',
      aspectRatio: 375 / 242,
      opacity: 0.7,
    },
    dotView: {
      position: 'absolute',
      bottom: 28,
      left: 0,
      right: 0,
    },
    content: {
      flex: 1,
      marginTop: -24,
      backgroundColor: colors.background,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      overflow: 'hidden',
    },
    scroll: {
      flex: 1,
      marginTop: 24,
    },
    scrollContainer: {
      paddingHorizontal: 24,
      paddingBottom: 30,
    },
    margin16: {
      margin: 16,
    },
    descriptionView: {
      width: '100%',
      marginTop: 16,
      // Themed backdrop so the description webview doesn't flash white in
      // dark mode while its HTML renders.
      backgroundColor: colors.background,
    },
    marginHorizontal16: {
      marginHorizontal: 16,
    },
    marginHorizontal8: {
      marginHorizontal: 8,
    },
    flexDirectionRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    justifyContentSpaceBetween: {
      justifyContent: 'space-between',
    },
    webViewContainer: {
      flex: 1,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      backgroundColor: colors.background,
    },
    rowContainer: {
      flexDirection: 'row',
      alignItems: Platform.OS === 'web' ? 'flex-end' : 'center',
      marginTop: 24,
    },
    rowItem: leftMargin => ({
      flex: 1,
      marginLeft: leftMargin,
    }),
    qtyContainer: {
      minWidth: 135,
      marginHorizontal: 0,
      borderWidth: 1,
      borderRadius: 16,
      marginTop: 8,
      borderColor: colors.borderMuted,
      flexDirection: 'row',
    },
    arrowImgContainer: {
      marginHorizontal: Platform.OS === 'web' ? 0 : 19,
      marginVertical: Platform.OS === 'web' ? 0 : 24,
      paddingVertical: Platform.OS === 'web' ? 24 : 0,
      paddingHorizontal: Platform.OS === 'web' ? 24 : 0,
      alignItems: 'center',
      justifyContent: 'center',
    },
    qtyTextContainer: {
      flex: 1,
      borderLeftWidth: 1,
      borderRightWidth: 1,
      borderLeftColor: colors.borderMuted,
      borderRightColor: colors.borderMuted,
      alignItems: 'center',
      justifyContent: 'center',
    },
    colorTextContainer: {
      flex: 1,
      marginLeft: 16,
      justifyContent: 'center',
    },
    flexRow: {
      flexDirection: 'row',
    },
    cartStatusDot: {
      height: 12,
      width: 12,
      borderRadius: 6,
      // Brand-pink notification dot stays literal (decorative — DARK-MODE.md);
      // the punch-out ring tracks the screen background behind the header.
      backgroundColor: COLORS.pink,
      borderWidth: 2,
      borderColor: colors.background,
      position: 'absolute',
      bottom: -4,
      right: -4,
    },
    centerItCarousel: {
      alignItems: 'center',
      justifyContent: Platform.OS === 'web' ? 'flex-start' : 'center',
    },
    centerIt: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    imageModalContainer: {
      flex: 1,
      backgroundColor: colors.overlay,
      // justifyContent: 'center',
    },
    productFullImage: {
      // Remote images have no intrinsic size; without an explicit width the
      // image renders 0-wide inside the centered PagerView child. 94% + the
      // 3% margins on each side fills the page width.
      width: '94%',
      height: '100%',
      borderRadius: 16,
      marginHorizontal: '3%',
    },
    carouselView: {
      width: '100%',
      height: '60%',
    },
    mh24: {
      marginHorizontal: 24,
    },
    iconButtonContainer: {
      marginHorizontal: 24,
      marginTop: 24,
    },
    fullFlex: {
      flex: 1,
    },
    regularFont: {fontFamily: FONTS.regularFont},
  });

export default makeStyles;
